import React, { useState, useEffect } from 'react';
import { api } from '../../services/api';
import toast from 'react-hot-toast';

export default function SROManagement() {
  const [items, setItems] = useState([]);
  const [file, setFile] = useState(null);
  const [url, setUrl] = useState('');
  const [title, setTitle] = useState('');

  const load = async () => {
    try {
      const res = await api.sro.list();
      setItems(res.data.items || []);
    } catch (e) {
      toast.error('Failed to load SROs');
    }
  };

  useEffect(() => { load(); }, []);

  const onUpload = async () => {
    if (!file) return toast.error('Choose a file');
    try {
      await api.sro.upload(file);
      toast.success('Uploaded and ingested');
      setFile(null);
      await load();
    } catch (e) {
      toast.error('Upload failed');
    }
  };

  const onAddUrl = async () => {
    if (!url) return toast.error('Enter URL');
    try {
      await api.sro.addFbrUrl({ url, title });
      toast.success('URL added');
      setUrl('');
      setTitle('');
      await load();
    } catch (e) {
      toast.error('Add URL failed');
    }
  };

  return (
    <div className="p-4 border rounded">
      <h3 className="text-lg font-semibold mb-2">SRO Knowledge Base</h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
        <div className="p-3 border rounded">
          <div className="font-medium mb-2">Upload SRO (PDF/HTML/TXT)</div>
          <input type="file" onChange={(e) => setFile(e.target.files?.[0] || null)} />
          <button className="ml-2 px-3 py-1 bg-blue-600 text-white rounded" onClick={onUpload}>Upload</button>
        </div>
        <div className="p-3 border rounded">
          <div className="font-medium mb-2">Add Official FBR URL</div>
          <input className="border p-1 w-full mb-2" placeholder="Title (optional)" value={title} onChange={(e)=>setTitle(e.target.value)} />
          <input className="border p-1 w-full" placeholder="https://fbr.gov.pk/..." value={url} onChange={(e)=>setUrl(e.target.value)} />
          <button className="mt-2 px-3 py-1 bg-green-600 text-white rounded" onClick={onAddUrl}>Add URL</button>
        </div>
      </div>

      <div className="mt-4">
        <div className="font-medium mb-2">Sources</div>
        <div className="overflow-auto">
          <table className="min-w-full text-sm">
            <thead>
              <tr className="text-left">
                <th className="p-2">ID</th>
                <th className="p-2">Filename/Title</th>
                <th className="p-2">Type</th>
                <th className="p-2">Status</th>
                <th className="p-2">Uploaded</th>
              </tr>
            </thead>
            <tbody>
              {items.map(it => (
                <tr key={it.id} className="border-t">
                  <td className="p-2">{it.id}</td>
                  <td className="p-2">{it.filename}</td>
                  <td className="p-2">{it.source_type}</td>
                  <td className="p-2">{it.status}</td>
                  <td className="p-2">{new Date(it.uploaded_at).toLocaleString()}</td>
                </tr>
              ))}
              {items.length === 0 && (
                <tr><td className="p-2" colSpan={5}>No sources yet</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}